<template>
	<v-card flat outlined>
		<v-container fluid class="pb-0">
			<v-row>
				<v-col cols="12" lg="12" class="pb-0 pt-0">
					<v-card flat class="pb-0 pt-0">
						<v-card-text class="pb-0">
							<v-row>
								<v-col class="pb-0 pt-0">
									<v-card-title class="justify-center align-center pa-2 pb-0 pt-0">{{
										$t('titles.statsPartners')
									}}</v-card-title>
								</v-col>
							</v-row>
							<v-row>
								<v-col class="pt-0">
									<TheTable
										:additional-filters="statsPartnersTable.additionalFilters"
										:default-sort="statsPartnersTable.defaultSort"
										:excel="true"
										:fields="statsPartnersTable.headers"
										:header-selection-key="'stats-partners-headers'"
										:height="statsPartnersTable.height"
										:total-records="statsPartnersTable.total"
										:filter-save-key="'stats-partners-filters'"
										@excel="excelExport"
										@headers="selectHeaders"
										@reload="reloadData"
									>
										<tr
											v-for="(item, key) in statsPartnersTable.items"
											:key="key"
											:class="{ 'cursor-pointer': true }"
										>
											<td v-if="statsPartnersTable.selectedHeaders.includes('partner')">
												{{ item.partner }}
											</td>
											<td
												style="text-align: right"
												v-if="statsPartnersTable.selectedHeaders.includes('income')"
											>
												{{
													Number(item.income) % 1 !== 0
														? item.income.charAt(item.income.length - 2) !== '0' &&
														  item.income.endsWith('0')
															? Number(item.income).toLocaleString('hr') + '0'
															: Number(item.income).toLocaleString('hr')
														: Number(item.income).toLocaleString('hr') + ',00'
												}}
											</td>
											<td
												style="text-align: right"
												v-if="statsPartnersTable.selectedHeaders.includes('discount')"
											>
												{{
													Number(item.discount) % 1 !== 0
														? item.discount.charAt(item.discount.length - 2) !== '0' &&
														  item.discount.endsWith('0')
															? Number(item.discount).toLocaleString('hr') + '0'
															: Number(item.discount).toLocaleString('hr')
														: Number(item.discount).toLocaleString('hr') + ',00'
												}}
											</td>
										</tr>
										<tr>
											<td></td>
											<td style="text-align: right">
												{{
													incomeSum != null
														? Number.isInteger(incomeSum)
															? incomeSum.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(incomeSum.toString())
															? incomeSum.toLocaleString('hr') + '0'
															: incomeSum.toLocaleString('hr')
														: ''
												}}
											</td>
											<td style="text-align: right">
												{{
													discountSum != null
														? Number.isInteger(discountSum)
															? discountSum.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(discountSum.toString())
															? discountSum.toLocaleString('hr') + '0'
															: discountSum.toLocaleString('hr')
														: ''
												}}
											</td>
										</tr>
									</TheTable>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Partners',
	components: { TheTable },
	data: function () {
		return {
			statsPartnersTable: {
				selectedHeaders: [],
				headers: [
					{
						text: this.$t('fields.partner'),
						value: 'partner',
						type: 'multiple|partners-buyers',
						allowFilter: true,
					},
					{
						text: this.$t('fields.totalIncome'),
						value: 'income',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
					{
						text: this.$t('fields.totalDiscount'),
						value: 'discount',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
				],
				additionalFilters: [
					{ text: this.$t('fields.dateCreated'), value: 'date', type: 'date_range' },
					{ text: this.$t('fields.totalIncome'), value: 'income', type: 'price_range' },
					{ text: this.$t('fields.totalDiscount'), value: 'discount', type: 'price_range' },
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'income',
					descending: true,
				},
			},
			incomeSum: 0,
			discountSum: 0,
		};
	},
	methods: {
		selectHeaders(headers) {
			this.statsPartnersTable.selectedHeaders = headers;
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.statsPartnersTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'stats-partners',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/stats-partners', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		reloadData(request) {
			this.statsPartnersTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'stats-partners',
				request,
				(data, success) => {
					if (success) {
						vm.statsPartnersTable.items = data.items;
						vm.statsPartnersTable.total = data.total;
						vm.incomeSum = data.income_sum;
						vm.discountSum = data.discount_sum;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.statsPartnersTable.height = window.innerHeight - 325 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		this.$myStore.commit('setBreadcrumbs', [{ text: this.$t('modules.stats'), href: '/#/stats', disabled: true }]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
